import { cn } from '../../utils/cn';

export default function Card({ children, className, hover, accent, onClick, ...props }) {
  return (
    <div
      onClick={onClick}
      className={cn(
        'bg-white rounded-2xl border border-surface-200/80 shadow-subtle overflow-hidden',
        hover && 'transition-all duration-300 hover:shadow-card hover:-translate-y-0.5 cursor-pointer',
        accent && 'border-t-[3px] border-t-accent-500',
        onClick && 'cursor-pointer',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
